export const API_URL = 'https://update-contatti-pianob-api-rsqcw56ovq-ew.a.run.app';